<template>
    <!-- Regular Carton Display -->
    <div class="carton-wrapper" v-if="currentCarton">
        <v-card class="carton-item" elevation="2">
            <div class="carton-image-container">
                <v-img
                    v-if="currentCarton.img"
                    :src="currentCarton.img"
                    contain
                    class="carton-img"
                    height="100%"
                    width="100%"
                >
                    <template v-slot:placeholder>
                        <div class="image-placeholder">
                            <v-icon size="24" color="brown">mdi-package-variant</v-icon>
                        </div>
                    </template>
                </v-img>
                <div v-else class="no-image-placeholder">
                    <v-icon size="40" color="brown">mdi-package-variant</v-icon>
                </div>
            </div>
        </v-card>

        <!-- Carton Label Badge -->
        <div class="item-label-badge carton-badge">
            <span class="badge-text">{{ currentCarton.sku }}</span>
        </div>
    </div>
    
    <!-- Empty State for Splittable Orders -->
    <div 
        v-else-if="currentCarton === null && mode !== 'packlist'"
        class="split-required-state"
    >
        <div class="split-icon">
            <v-icon size="24" color="orange darken-2">mdi-package-variant-closed</v-icon>
        </div>
        <div class="split-details">
            <div class="split-title">Paket aufteilung erforderlich</div>
            <div class="split-subtitle">Kein passender Karton gefunden</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CartonItem',
    props: {
        currentCarton: {
            type: Object,
            default: () => null
        },
        mode: {
            type: String,
            default: 'packlist'
        }
    }
}
</script>

<style scoped>
/* Carton Wrapper - matches other items */
.carton-wrapper {
    position: relative;
    width: 100px;
    height: 100px;
    flex-shrink: 0;
    flex-grow: 0;
}

.carton-item {
    width: 100px;
    height: 100px;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    flex-grow: 0;
    aspect-ratio: 1/1;
    position: relative;
    overflow: hidden;
}

/* Image Container */
.carton-image-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.carton-img {
    padding: 12px;
}

.image-placeholder,
.no-image-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: #fff3e0;
}

/* Item Label Badge - matches other items */
.item-label-badge {
    position: absolute;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%);
    color: white;
    padding: 4px 12px;
    border-radius: 2px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.5px;
    z-index: 10;
    display: flex;
    align-items: center;
    white-space: nowrap;
    border: 1px solid rgba(255, 255, 255, 0.3);
    max-width: 90px;
    overflow: hidden;
}

/* Badge Text - truncate with ellipsis */
.badge-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Carton Badge - Light orange gradient */
.carton-badge {
    background: linear-gradient(135deg, #ffb74d 0%, #ff9800 100%);
    box-shadow: 0 2px 8px rgba(255, 152, 0, 0.4);
}

/* Tablet-specific adjustments (768px - 1366px) */
@media (min-width: 768px) and (max-width: 1366px) {
    .carton-wrapper,
    .carton-item {
        width: 80px;
        height: 80px;
    }

    .item-label-badge {
        bottom: -10px;
        padding: 3px 10px;
        font-size: 9px;
        max-width: 72px;
    }

    .carton-img {
        padding: 8px;
    }
}

/* Empty State for Splittable Orders */
.split-required-state {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 12px;
    background-color: #fff3e0;
    border: 2px dashed #ff9800;
    border-radius: 8px;
    padding: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.split-icon {
    flex-shrink: 0;
}

.split-details {
    flex: 1;
    min-width: 0;
}

.split-title {
    font-size: 14px;
    font-weight: 600;
    color: #e65100;
    line-height: 1.2;
    margin-bottom: 4px;
    word-break: break-word;
}

.split-subtitle {
    font-size: 12px;
    color: #ff9800;
    line-height: 1.2;
}
</style>